import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      onModerationStatuses: ['processing', 'new', 'reopened'],
      outOfPoolStatuses: ['cancelled', 'declined'],
    };
  },
  methods: {
    apartmentStatus(apartment): string | false | undefined {
      if (apartment) {
        if (apartment.in_rent) {
          return 'in_rent';
        } else if (!apartment.in_rent && (!apartment.rent_ad_request
            || this.outOfPoolStatuses.includes(apartment.rent_ad_request.status))) {
          return 'out_of_pool';
        } else if (
            !apartment.in_rent
            && apartment.rent_ad_request
            && this.onModerationStatuses.includes(apartment.rent_ad_request.status)) {
          return 'on_moderation';
        } else if (!apartment.in_rent && apartment.rent_ad_request && apartment.rent_ad_request.status === 'solved') {
          return 'in_pool';
        } else if (!apartment.in_rent && apartment.rent_ad_request && apartment.rent_ad_request.status === 'used') {
          return 'on_hold';
        }
      } else {
        return false;
      }
    },
  },
});
